import React, {useState} from "react"
import {
    Button,
    ButtonGroup,
    FormControl,
    FormLabel,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Textarea
} from "@chakra-ui/react"

type FeedbackModalProps = {
    message: string,
    voteKey: string,
    onClose: (voteKey: string, val?: string) => void
}

export function FeedbackModal({message, voteKey, onClose}: FeedbackModalProps) {

    const [value, setValue] = useState<string>("")

    function onPass() {
        onClose(voteKey)
    }

    function onSubmit() {
        console.log("val", value)
        onClose(voteKey, value)

    }


    return (
        <Modal isOpen onClose={onPass}>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>Feedback</ModalHeader>
                <ModalCloseButton/>
                <ModalBody>
                    <p className="whitespace-break-spaces mb-4">{message}</p>

                    <FormControl>
                        <FormLabel htmlFor="reason">Please tell us a better answer/translation</FormLabel>
                        <Textarea
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                        />
                    </FormControl>

                </ModalBody>

                <ModalFooter>
                    <ButtonGroup gap={4}>
                        <Button onClick={onPass}>Pass</Button>
                        <Button colorScheme="blue" onClick={onSubmit}>
                            Submit
                        </Button>
                    </ButtonGroup>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}